import React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../common/InputField";
import Button from "../common/Button";

// Scss imports
import css from "./RegisterForm.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { signup } from "../../redux/actions/signupAction";

interface RegisterFormProps {
  handleChange: Function;
  email: string;
  password: string;
  repeatedPassword: string;
  onClickButtonHandler: Function;
  errorEmailText: string;
  errorPasswordText: string;
  errorRepeatedPasswordText: string;
  disabledButton: boolean;
  onInputEmail: Function;
  onInputPassword: Function;
}

const RegisterForm: React.FC<RegisterFormProps> = ({
  handleChange,
  email,
  password,
  repeatedPassword,
  disabledButton,
  errorEmailText,
  errorPasswordText,
  errorRepeatedPasswordText,
  onInputEmail,
  onInputPassword,
  onClickButtonHandler,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Е пошта"
          name="email"
          id="email"
          type="email"
          placeholder="email@gmail.com"
          value={email}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "email@gmail.com")}
          errorText={errorEmailText}
          onInputHandler={onInputEmail}
        />
      </div>

      <div className={css.inputFieldWrapper}>
        <InputField
          label="Шифра"
          name="password"
          id="password"
          type="password"
          placeholder="password@gmail.com"
          value={password}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Password12345")}
          errorText={errorPasswordText}
          onInputHandler={onInputPassword}
        />
      </div>

      <InputField
        label="Потврда"
        name="repeatedPassword"
        id="repeated"
        type="password"
        placeholder="password@gmail.com"
        value={repeatedPassword}
        handleChange={handleChange}
        handleOnFocus={(e: any) => (e.target.placeholder = "")}
        handleOnBlur={(e: any) => (e.target.placeholder = "Password12345")}
        errorText={errorRepeatedPasswordText}
      />

      <div className={css.buttonHolder}>
        <Button
          disabledButton={disabledButton}
          text="Региструј се"
          onButtonClickHandler={() => {
            console.log("vuca");
            /*dispatch(
              signup(
                {
                  email: email,
                  password: password,
                  passwordConfirm: repeatedPassword,
                },
                history
              )
            );*/
          }}
        />
        <Link to="/signin">
          <p>Већ имате налог, улогујте се</p>
        </Link>
      </div>
    </div>
  );
};

export default RegisterForm;
